module.exports = __webpack_public_path__ + "static/img/335.bfb1d745.png";